import isEmpty from 'lodash.isempty';
import { VALIDATION, STYLE } from '../../../../constants/shared/ZoGConstants';
import { getEndPmPeriod } from '../../../../utils/shared/pmUtils';
import { MEASURE_DISPLAY_NAME, MEASURE } from '../../../../constants/shared/MeasuresConstants';

const { CLPL, MAZE, ORF_ACC, FLO_PREC } = MEASURE;
const { EMPTY_RANGE_MIN, RANGE_MAX, READING_ACCURACY_MAX, EMPTY, DOT } = VALIDATION.VALUE;
const {
    ENTER_POSITIVE_INTEGER,
    ENTER_POSITIVE_INTEGER_OR_DECIMAL_ONLY,
    GOALS_CAN_NOT_BE_LESS_AVERAGE,
    VALUE_MUST_BE_LESS_OR_EQUAL_100,
    VALUE_MUST_BE_LESS_999,
} = VALIDATION.MESSAGE;
const { ERROR_VALIDATION_OBJECT, SUCCESS_VALIDATION_OBJECT } = STYLE;

const isValueValid = (measure, value) => {
    const basicComprehensionRegExp = new RegExp(VALIDATION.BASIC_COMPREHENSION_REG_EXP);
    const basicComprehensionMeasures = [MAZE, CLPL];

    return basicComprehensionMeasures.includes(measure)
        ? basicComprehensionRegExp.test(value)
        : !value.includes(DOT);
};

const handleValidationFunction = ({
    event,
    setCurrentValue,
    studentSaveInfo,
    additionalInfo,
    growthRatePrev,
    getStrugglingAdvancedGoalForMeasure,
    appName = '',
}) => {
    let { value } = event.target;
    const { measure } = studentSaveInfo;
    const {
        averageRange,
        selectedPmPeriod,
        zogStatuses,
        interpsByMeasureGrade,
        growthZones,
        customGoal = 0,
        handleSaveStudentGoal,
        goalSetLookerEvent,
    } = additionalInfo;
    const basicComprehensionMeasures = [MAZE, CLPL];
    const readingAccuracyMeasures = [ORF_ACC, FLO_PREC];

    const measureMin = isEmpty(averageRange) ? EMPTY_RANGE_MIN : averageRange.min;
    const measureMax = readingAccuracyMeasures.includes(measure) ? READING_ACCURACY_MAX : RANGE_MAX;

    goalSetLookerEvent({
        selectedPeriod: selectedPmPeriod,
        measure: MEASURE_DISPLAY_NAME[measure],
        goalScore: value,
        prevGoalScore: customGoal,
        growthRatePrev,
    });

    if (value === customGoal.toString()) {
        return SUCCESS_VALIDATION_OBJECT;
    }

    if (value === EMPTY) {
        const defaultValue =
            getStrugglingAdvancedGoalForMeasure(
                measure,
                getEndPmPeriod(selectedPmPeriod),
                [zogStatuses],
                interpsByMeasureGrade,
                [growthZones],
                appName,
            ) || 0;
        setCurrentValue(defaultValue);
        value = defaultValue.toString();
    }

    if (value >= 0 && value < measureMin) {
        return {
            ...ERROR_VALIDATION_OBJECT,
            text: GOALS_CAN_NOT_BE_LESS_AVERAGE,
        };
    }

    if (value > measureMax) {
        return {
            ...ERROR_VALIDATION_OBJECT,
            text: readingAccuracyMeasures.includes(measure)
                ? VALUE_MUST_BE_LESS_OR_EQUAL_100
                : VALUE_MUST_BE_LESS_999,
        };
    }

    if (value >= measureMin && isValueValid(measure, value)) {
        handleSaveStudentGoal({ ...studentSaveInfo, goalValue: Number(value) });
        return SUCCESS_VALIDATION_OBJECT;
    }

    return {
        ...ERROR_VALIDATION_OBJECT,
        text: basicComprehensionMeasures.includes(measure)
            ? ENTER_POSITIVE_INTEGER_OR_DECIMAL_ONLY
            : ENTER_POSITIVE_INTEGER,
    };
};

export default handleValidationFunction;
